import Component from 'gia/Component';
import { gsap } from "gsap";


export default class Testimonials extends Component {
  constructor(element) {
    super(element);
    this.ref = {
      boxes: [],
      boxLarge: [],
      boxPetit: []
    };
  }

  mount() {
    let that = this;


    let fixHeight = this.ref.boxes[0].offsetHeight;
    if (window.innerWidth >= 728) {
      this.ref.boxes.forEach(function(box, index) {
        gsap.set(box, {height: fixHeight});
        box.addEventListener('click', function(e) {
          if (box.classList.contains('active')) {
            return;
          }
          // that.closeActiveBox();
          that.openBox(index);
        })
      })

    }

  }

  openBox(i) {
    console.log(i);
    let that = this;
    let activeIndex = -1;
    let activeBox = {};

    this.ref.boxes.forEach(function(subbox, index) {
      if (subbox.classList.contains('active')) {
        console.log('active');
        console.log(index);
        activeBox = that.ref.boxes[index];
        activeIndex = index;
      }
    });

    let boxLargeInner = this.ref.boxLarge[activeIndex];
    let boxPetitInner = this.ref.boxPetit[i];
    let boxLarge = this.ref.boxes[activeIndex];
    let boxPetit = this.ref.boxes[i];

    let boxLargeInnerNew = this.ref.boxLarge[i];
    let boxPetitInnerNew = this.ref.boxPetit[activeIndex];

    boxLarge.classList.remove('active');
    boxPetit.classList.add('active');

    console.log(activeBox);
    let tl = gsap.timeline();
    tl.to(boxLargeInner, {
        opacity: 0, duration: 0.3, onComplete: function() {
          boxLargeInner.classList.add('hidden');
        }
      })
      .to(boxPetitInner, {
        opacity: 0, duration: 0.3, onComplete: function() {
          boxPetitInner.classList.add('hidden');
        }
      }, '-=0.3')
      .to(boxLarge, {width: '15%', duration: 0.3, ease: "power1.inOut"})
      .to(boxPetit, {width: '70%', duration: 0.3, ease: "power1.inOut"}, '-=0.3')

      .to(boxLargeInnerNew, {
        opacity: 1, duration: 0.3, onStart: function() {
          boxLargeInnerNew.classList.remove('hidden');
        }
      })
      .to(boxPetitInnerNew, {
        opacity: 1, duration: 0.3, onStart: function() {
          boxPetitInnerNew.classList.remove('hidden');
        }
      }, '-=0.3');

  }
}